export default __webpack_public_path__ + "static/media/73t.ee4ae565.jpg";